import { APP_CONFIG } from '@/lib/app/config';

export function getAbsoluteWebFeedHref(href: any) {
  const path = hrefToPath(href);
  const origin =
    typeof globalThis.location?.origin === 'string'
      ? globalThis.location.origin
      : APP_CONFIG.webBaseURL;
  return `${origin}${path}`;
}

function hrefToPath(href: any) {
  const pathname = String(href?.pathname ?? '/events');
  const params = href?.params && typeof href.params === 'object' ? href.params : {};
  const id = typeof params.id === 'string' ? params.id : '';
  const username = typeof params.username === 'string' ? params.username : '';
  const concretePath = pathname.replace('[id]', id).replace('[username]', username);
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (key === 'id' || key === 'username' || value == null) return;
    query.set(key, String(value));
  });

  const suffix = query.toString();
  return suffix ? `${concretePath}?${suffix}` : concretePath;
}
